import { useState, useEffect } from 'react';
import { Overlay, Popover, Button, Form } from 'react-bootstrap';
import i18n from '../../../../../../_translations/i18n';

const DataPanelFilterSelectionModal = ({ show, onHide, onConfirm, selectedOptions = [], targetRef, options, simType }) => {
    const getOptionKey = (option) => option.short;

    const defaultSelected = selectedOptions && selectedOptions.length > 0
        ? selectedOptions
        : options.slice(0, 3);

    const [selected, setSelected] = useState(defaultSelected);

    const isRTL = i18n.dir && i18n.dir() === 'rtl';

    useEffect(() => {
        setSelected(selectedOptions && selectedOptions.length > 0 ? selectedOptions : options.slice(0, 3));
    }, [selectedOptions, show, options]);

    const handleCheckboxChange = (option) => {
        const isSelected = selected.some((item) => getOptionKey(item) === getOptionKey(option));
        if (isSelected) {
            setSelected(selected.filter((item) => getOptionKey(item) !== getOptionKey(option)));
        } else if (selected.length < 3) {
            setSelected([...selected, option]);
        }
    };

    const handleConfirm = () => {
        onConfirm(selected);
        onHide();
    };

    const isDisabled = (option) => {
        return !selected.some((item) => getOptionKey(item) === getOptionKey(option)) && selected.length >= 3;
    };

    const isDarkMode = document.body.classList.contains('d-mode');

    return (
        <Overlay
            show={show}
            target={targetRef?.current}
            placement="bottom"
            containerPadding={10}
            rootClose
            onHide={onHide}
        >
            <Popover
                id="filter-selection-popover"
                dir={isRTL ? 'rtl' : 'ltr'}
                style={{
                    border: 'none',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                    WebkitBoxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                    background: isDarkMode ? '#22272f' : '#fff',
                }}
            >
                <h6 style={{ padding: isRTL ? '10px 16px 10px 0' : '10px 0 10px 16px' }}>
                    <span style={isDarkMode ? { color: '#fff' } : {}}>
                        {i18n.t("CHOOSE_3_FILTER_OPTIONS")}
                    </span>
                </h6>
                <Popover.Body style={{
                    padding: isRTL ? '0 16px 16px 0' : '0 0 16px 16px'
                }}>
                    <Form>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px 16px',
                                paddingRight: isRTL ? undefined : '16px',
                                paddingLeft: isRTL ? '16px' : undefined,
                                maxHeight: (simType === 'AUI' && window.devicePixelRatio > 1) ? '150px' : '250px',
                                overflowY: 'auto',
                                direction: isRTL ? 'rtl' : 'ltr',
                            }}
                        >
                            {options.map((option) => (
                                <div key={getOptionKey(option)}>
                                    <Form.Check
                                        type="checkbox"
                                        label={
                                            <span style={isDarkMode ? { color: '#fff', fontWeight: 400 } : {fontWeight: 400}}>
                                                ({option.displayShort || option.short}) {i18n.t(option.label)}
                                            </span>
                                        }
                                        checked={selected.some((item) => getOptionKey(item) === getOptionKey(option))}
                                        disabled={isDisabled(option)}
                                        onChange={() => handleCheckboxChange(option)}
                                        style={{ marginBottom: '8px', whiteSpace: 'normal' }}
                                        className="black-checkbox"
                                        reverse={isRTL ? true : false}
                                    />
                                    <style>
                                        {`
                                        .black-checkbox .form-check-input:checked[type=checkbox] {
                                            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='black' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e");
                                        }
                                        `}
                                    </style>
                                </div>
                            ))}
                        </div>
                    </Form>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: isRTL ? 'row-reverse' : 'row',
                            justifyContent: isRTL ? 'flex-start' : 'flex-end',
                            width: '100%',
                            paddingTop: 8,
                        }}
                    >
                        <style>{`
              .data-panel-btn {
                transition: opacity 0.15s;
              }
              .data-panel-btn:hover:not(:disabled) {
                opacity: 0.8 !important;
              }
            `}</style>
                        <Button
                            className="data-panel-btn"
                            size="sm"
                            onClick={onHide}
                            style={{
                                margin: '0 8px',
                                backgroundColor: '#374151',
                                border: 'none',
                                borderRadius: '20px',
                                padding: '2px 16px',
                                fontSize: '0.85rem',
                                minWidth: 64,
                            }}
                        >
                            {i18n.t("CANCEL")}
                        </Button>
                        <Button
                            className="data-panel-btn"
                            size="sm"
                            onClick={handleConfirm}
                            disabled={selected.length === 0}
                            style={{
                                backgroundColor: '#9B4EDF',
                                border: 'none',
                                borderRadius: '20px',
                                padding: '2px 16px',
                                fontSize: '0.85rem',
                                minWidth: 64,
                                opacity: selected.length === 0 ? 0.6 : 1,
                            }}
                        >
                            {i18n.t("CONFIRM")}
                        </Button>
                    </div>
                </Popover.Body>
            </Popover>
        </Overlay>
    );
};

export default DataPanelFilterSelectionModal;
